import { createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { deleteData, getData, postData, putData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";


export const addDocument = createAsyncThunk(
    "admin/addDocument",
    async (data, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await postData(`/documents/add-document`, data);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const fetchdocuments = createAsyncThunk(
    "admin/fetcdocuments",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await getData(`/documents/get-documents`);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const updateDocument = createAsyncThunk(
  "admin/updateDocument",
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setShowError(false));
      const res = await putData(`/documents/update-document?id=${id}`, data);
      return res;
    } catch (error) {
      return handleError(error, dispatch, rejectWithValue);
    }
  }
);

export const deleteDocument = createAsyncThunk(
    "admin/deleteDocument",
    async (id, { rejectWithValue, dispatch }) => {
        try {
            dispatch(setShowError(false));
            const res = await deleteData(`/documents/delete-document?id=${id}`);
            return res;
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

